import { GAME_ID, REDUX_ACTIONS } from 'a/wordSlide/data/constants';

const initialState = {
  highestLevelEarned: 0,
};

const gameDetailsReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_HIGHEST_LEVEL_EARNED:
      return {
        ...state,
        highestLevelEarned: payload.level,
      };

    default:
      return state;
  }
};

export default gameDetailsReducer;
